import {AxiosError} from 'axios';

type FailedResponseData = {
  headers: {
    requestid: string,
    responseid: string,
    response_server_time: string,
  },
  errorCode: number,
  body?: {[key: string]: unknown}
};

export class ApiError extends AxiosError<FailedResponseData, any> {}

export class UserAlreadyExistsError extends Error {}